import { Patient } from "../../../utils/api-objects/Patient";

export interface SubscriptionType {
  id: string;
  label: string;
  subType: string;
  isProduct: boolean;
}

export const getSubscriptionTypeLabel = (subType: string, products: string[]): string => {
  // Subscription types
  if (subType === "sub-health") {
    return "Percorso Health";
  } else if (subType === "sub-nutrition") {
    return "Percorso Nutrition";
  } else if (subType === "sub-metabolic-health") {
    return "Percorso Medico e Nutrizionale";
  } else if (subType === "sub-metabolic-health-lite") {
    return "Percorso Medico di Dimagrimento";
  }
  
  // Product types
  if (products.includes("dna-test")) {
    return "DNA Test";
  } else if (products.includes("blood-test")) {
    return "Analisi degli Aminoacidi";
  } else if (products.includes("expert-consult")) {
    return "Consulto con medico";
  } else if (products.includes("metabolic-hook")) {
    return "Visita Medica Specialistica";
  } else if (products.includes("nutritionist-consult")) {
    return "Consulto con nutrizionista";
  }
  
  return "Altro";
};

export const extractSubscriptionTypes = (patients: Patient[]): SubscriptionType[] => {
  const typeMap = new Map<string, SubscriptionType>();
  
  patients.forEach(patient => {
    // Handle subscription types
    if (patient.sub_type && patient.sub_type !== "") {
      const label = getSubscriptionTypeLabel(patient.sub_type, patient.products);
      const key = `sub_${patient.sub_type}`;
      
      if (!typeMap.has(key)) {
        typeMap.set(key, {
          id: key,
          label,
          subType: patient.sub_type,
          isProduct: false
        });
      }
    }
    
    // // Handle product types
    // patient.products.forEach(product => {
    //   const label = getSubscriptionTypeLabel("", [product]);
    //   const key = `prod_${product}`;
      
    //   if (!typeMap.has(key) && label !== "Altro") {
    //     typeMap.set(key, {
    //       id: key,
    //       label,
    //       subType: "",
    //       isProduct: true
    //     });
    //   }
    // });
  });
  
  return Array.from(typeMap.values()).sort((a, b) => a.label.localeCompare(b.label));
};

export const getPatientSubscriptionType = (patient: Patient): SubscriptionType | null => {
  if (patient.sub_type && patient.sub_type !== "") {
    const label = getSubscriptionTypeLabel(patient.sub_type, patient.products);
    return {
      id: `sub_${patient.sub_type}`,
      label,
      subType: patient.sub_type,
      isProduct: false
    };
  }
  
  // Check for products
  for (const product of patient.products) {
    const label = getSubscriptionTypeLabel("", [product]);
    if (label !== "Altro") {
      return {
        id: `prod_${product}`,
        label,
        subType: "",
        isProduct: true
      };
    }
  }
  
  return null;
}; 